import { render } from "./bank-settings-grid.vue?vue&type=template&id=cafd86dc&scoped=true"
import script from "./bank-settings-grid.vue?vue&type=script&lang=js"
export * from "./bank-settings-grid.vue?vue&type=script&lang=js"

import "./bank-settings-grid.vue?vue&type=style&index=0&id=cafd86dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cafd86dc"]])

export default __exports__